import React from 'react';
import Zoom from 'react-reveal/Zoom';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import FooterSocial from './partials/FooterSocial';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

const Footer = ({
  className,
  topOuterDivider,
  topDivider,
  ...props
}) => {

  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    <footer
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={
          classNames(
            'site-footer-inner',
            topDivider && 'has-top-divider'
          )}>
          <div className="footer-top space-between text-xxs">
            <Zoom left>
              <FooterSocial />
            </Zoom>

            <br />
            <br />

            <Zoom right>
              <strong>
                (41) 3078-3583
                <br />
                Rua D. Pedro Augusto Menna Barreto Monclaro, 36, Loja 2              
                <br />
                Curitiba - PR
              </strong>
            </Zoom>              
          </div>
          <div className="footer-bottom space-between text-xxs invert-order-desktop">
            <div className="footer-copyright">Joao Guilherme Piá de Andrade. 2023 Todos Direitos Reservados.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
